"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = RadioButtonsGroup;

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _Radio = _interopRequireDefault(require("@material-ui/core/Radio"));

var _RadioGroup = _interopRequireDefault(require("@material-ui/core/RadioGroup"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _FormLabel = _interopRequireDefault(require("@material-ui/core/FormLabel"));

var _reactI18next = require("react-i18next");

var _GenericStore = require("../store/GenericStore");

function RadioButtonsGroup(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var block = props.block,
      parentPath = props.parentPath;

  var _useDataStore = (0, _GenericStore.useDataStore)(parentPath),
      _useDataStore2 = (0, _slicedToArray2["default"])(_useDataStore, 2),
      value = _useDataStore2[0],
      setValue = _useDataStore2[1];

  var radioButtons = (0, _keys["default"])(block.content);

  var handleChange = function handleChange(event) {
    setValue(event.target.value);
  };

  return /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
    component: "fieldset"
  }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
    component: "legend"
  }, block.label), /*#__PURE__*/_react["default"].createElement(_RadioGroup["default"], {
    row: block.styling.isRow,
    "aria-label": "gender",
    name: "gender1",
    value: value,
    onChange: handleChange
  }, radioButtons.map(function (radio) {
    return /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
      value: block.content[radio].value,
      control: /*#__PURE__*/_react["default"].createElement(_Radio["default"], null),
      label: t(block.content[radio].label)
    });
  })));
}